var map = {
	"./Group 1 (1).svg": 3620,
	"./Group 1 (2).svg": 8484,
	"./Group 1 (3).svg": 7892,
	"./SampleNonThalesVisitorCsv.csv": 8104,
	"./SampleThalesVisitorCsv.csv": 280,
	"./android.svg": 4832,
	"./arrow-left.svg": 2112,
	"./arrow-right.svg": 7668,
	"./arrow-up-down.svg": 2940,
	"./ast-logo.png": 3704,
	"./ast-mark.png": 6396,
	"./background.jpg": 1199,
	"./bg.png": 3676,
	"./bg.webp": 3708,
	"./chart-square.svg": 1448,
	"./checkkout.png": 5016,
	"./checkouticon.png": 3912,
	"./closeicon.svg": 5356,
	"./config-department.svg": 9464,
	"./config-employee.svg": 1964,
	"./config-repository.svg": 2848,
	"./config-team.svg": 3648,
	"./dashboard-active.svg": 2975,
	"./dashboard.svg": 1132,
	"./dote.svg": 5692,
	"./file-down.svg": 7054,
	"./hi_logo.png": 7800,
	"./img1.png": 7908,
	"./img2.png": 8148,
	"./importCsv.svg": 1908,
	"./li_arrow-right-left.svg": 9608,
	"./li_arrow-up-right.svg": 8084,
	"./li_calendar-days.svg": 9196,
	"./li_calendar.svg": 3884,
	"./li_chevron-down.svg": 1636,
	"./li_file-down.svg": 2036,
	"./li_map.svg": 524,
	"./li_plus.svg": 460,
	"./li_ungroup.svg": 5028,
	"./li_upload.svg": 9288,
	"./li_users.svg": 4284,
	"./loading.gif": 9840,
	"./loadings.gif": 7340,
	"./loadingsss.gif": 2260,
	"./location.png": 8696,
	"./login-first-img.svg": 4816,
	"./login-sec-img.png": 9136,
	"./login.png": 5728,
	"./login_logo.svg": 6160,
	"./menubar.svg": 3568,
	"./nric.png": 2876,
	"./office.png": 2664,
	"./phone.png": 1720,
	"./place-profile.png": 6772,
	"./profile-right-arrow.svg": 4556,
	"./profile.png": 8667,
	"./report.png": 5533,
	"./sampleCsv.csv": 6092,
	"./search.svg": 4048,
	"./settings-admin.svg": 9784,
	"./settings.svg": 2183,
	"./streamline-plump_file-report-remix.png": 3504,
	"./u_image-upload.svg": 8949,
	"./u_search.svg": 9500,
	"./upload-icon.svg": 3264,
	"./vendorcheckin.png": 7828,
	"./visitorcheckin.png": 9140,
	"./warning.svg": 7504
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 372;